import React from 'react'
import './Learning.css'
import '../../components/ResponsivePlayer.css'
import EducationSectionBlock from '../../components/Education/EducationSectionBlock'
import EducationLayout from '../../components/Education/EducationLayout'
import {
  ID_CS_CERTIFICATIONS,
  ID_CS_MEMBERSHIP,
  ID_ONE_ON_ONE,
  SKU_CS_ART_IN_PERSON,
  SKU_CS_ART_VIRTUAL,
  SKU_CS_SPEC_IN_PERSON,
  SKU_CS_SPEC_VIRTUAL
} from 'src/constants'
import { useProductPrice } from '../../customHooks/useProductPrice'
import { useAdditionalProductPrice } from 'src/customHooks/useAdditionalProductPrice'
import additionalEducationalResources from '../../components/Education/data/additionalEducationalResources.json'
import additionalOnlineAcademyResourcesCS from '../../components/Education/data/additionalOnlineAcademyResourcesCS.json'

export default function LearningCS() {
  const { prices: counterSketchCertifications } = useProductPrice(ID_CS_CERTIFICATIONS)
  const { additionalResources: counterSketchOnlineAcademy } = useAdditionalProductPrice(
    additionalOnlineAcademyResourcesCS,
    [ID_CS_MEMBERSHIP]
  )
  const { additionalResources } = useAdditionalProductPrice(additionalEducationalResources, [
    ID_ONE_ON_ONE,
    ID_CS_MEMBERSHIP
  ])

  return (
    <EducationLayout>
      <EducationSectionBlock
        title='education.certifications.title'
        descriptions={[
          'education.certifications.counterSketchDescription',
          'education.certifications.counterSketchDescription2'
        ]}
        pricesData={counterSketchCertifications}
        sectionData={[
          {
            sku: SKU_CS_ART_IN_PERSON,
            imageUrl: 'https://meteor.stullercloud.com/das/137639302?wid=700',
            descriptionId: 'education.counterSketchArtisanInPerson'
          },
          {
            sku: SKU_CS_ART_VIRTUAL,
            imageUrl: 'https://meteor.stullercloud.com/das/139782900?wid=700',
            descriptionId: 'education.counterSketchArtisanVirtual'
          },
          {
            sku: SKU_CS_SPEC_IN_PERSON,
            imageUrl: 'https://meteor.stullercloud.com/das/134510529?wid=700',
            descriptionId: 'education.counterSketchSpecialistInPerson'
          },
          {
            sku: SKU_CS_SPEC_VIRTUAL,
            imageUrl: 'https://meteor.stullercloud.com/das/139782443?wid=700',
            descriptionId: 'education.counterSketchSpecialistInVirtual'
          }
        ]}
      />
      <EducationSectionBlock
        title='education.onlineAcademy.titleCS'
        pricesData={counterSketchOnlineAcademy}
        sectionData={[
          {
            imageUrl: 'https://meteor.stullercloud.com/das/134498037?wid=700'
          }
        ]}
      />
      <EducationSectionBlock
        title='education.additionalResources.title'
        descriptions={['education.additionalResources.counterSketchDescription']}
        pricesData={additionalResources}
        sectionData={[
          { imageUrl: 'https://meteor.stullercloud.com/das/134498035?wid=700' },
          { imageUrl: 'https://meteor.stullercloud.com/das/134498034?wid=700' }
        ]}
      />
    </EducationLayout>
  )
}
